import ErrorTenantNotExist from "./components/TenantNotExist"

let module = "errors"

export default [{ path: "tenant-not-exist", component: ErrorTenantNotExist, meta: { module: module, permissions: ["all"] } }]
